import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, TeamChip, CtaBand, Reveal } from "../components/ui.js";

/* LEVELUP ONE — ทีมงาน (Teams) */
export default class Teams extends Component {
  componentDidMount() { loading(false); window.scrollTo(0, 0); }
  render() {
    const people = [
      { face: "👨‍💼", name: "ผู้ก่อตั้ง", role: "CEO & Strategy", bg: "#eef2ff" },
      { face: "👩‍💻", name: "หัวหน้าวิศวกร", role: "CTO / Engineering", bg: "#f0fdf4" },
      { face: "🎨", name: "หัวหน้าออกแบบ", role: "Head of Design", bg: "#fef3c7" },
      { face: "🧠", name: "วิศวกร AI", role: "AI/ML Engineer", bg: "#fae8ff" },
      { face: "💻", name: "ทีมพัฒนา", role: "Full-stack Devs", bg: "#ecfeff" },
      { face: "📞", name: "ทีมที่ปรึกษา", role: "Solution Consultant", bg: "#ffe4e6" },
      { face: "🛠️", name: "ทีมซัพพอร์ต", role: "Customer Success", bg: "#e0f2fe" },
      { face: "📊", name: "ทีมการตลาด", role: "Growth & MarTech", bg: "#fce7f3" },
    ];
    return (
      <div className="nx">
        <Navbar />
        <PageHero crumb="ทีมงาน" eyebrow="ทีมงาน" title="ทีมสหสาขาที่อยู่เบื้องหลังทุกโปรเจกต์"
          subtitle="วิศวกร นักออกแบบ และที่ปรึกษา ที่ทำงานร่วมกันเพื่อผลลัพธ์ที่ดีที่สุดของลูกค้า" />
        <section className="nx-section">
          <div className="container">
            <Reveal><SectionHead center eyebrow="คนของเรา" title="พบกับทีม LevelUp One" /></Reveal>
            <div className="row g-4 mt-2">
              {people.map((p, i) => (
                <div className="col-6 col-lg-3" key={p.name}>
                  <Reveal delay={i * 50}><TeamChip {...p} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaBand title="อยากเป็นส่วนหนึ่งของทีม?" text="เราเปิดรับเพื่อนร่วมทีมเสมอ ดูตำแหน่งที่เปิดรับได้ที่หน้าร่วมงานกับเรา" />
        <Footer />
      </div>
    );
  }
}
